import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { NgxInlineLoaderComponent } from './ngx-inline-loader/ngx-inline-loader.component';
import { NgxSearchComponent } from './ngx-search/ngx-search.component';
import { NgxHeaderComponent } from './ngx-header/ngx-header.component';
import { RouterModule } from '@angular/router';
import { NgxCardLayoutComponent } from './ngx-card-layout/ngx-card-layout.component';
import { NgxFullpageLoaderComponent } from './ngx-fullpage-loader/ngx-fullpage-loader.component';
import { NgxListDataViewComponent } from './ngx-list-data-view/ngx-list-data-view.component';

const components = [
    NgxInlineLoaderComponent,
    NgxSearchComponent,
    NgxHeaderComponent,
    NgxCardLayoutComponent,
    NgxFullpageLoaderComponent,
    NgxListDataViewComponent
]

@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        ButtonModule,
        ProgressSpinnerModule,
        RouterModule
    ],
    exports: [...components]
})
export class NgxWrapperSharedModule { }
